export default __webpack_public_path__ + "static/media/voucherUsage.a76a3674.svg";